import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import VideoCard from "@/components/VideoCard";
import Reveal from "@/components/Reveal";
import Seo from "@/components/Seo";

const FILTERS = ["Tous", "Enseignements", "Prophétie", "Louange", "Témoignages"];

const Videos = () => {
  const [videos, setVideos] = useState([]);
  const [active, setActive] = useState("Tous");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/videos").then((r) => setVideos(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const filtered = active === "Tous" ? videos : videos.filter((v) => v.category === active);

  return (
    <div>
      <Seo
        title="Vidéos & Enseignements bibliques"
        description="Messages prophétiques, enseignements bibliques, louange et témoignages du Prophète Steeve Orphôss. Regardez la médiathèque du ministère international."
        path="/videos"
      />
      <PageHeader
        overline="Médiathèque"
        title="Messages & Enseignements"
        subtitle="Plongez dans les messages prophétiques, enseignements, louange et témoignages du ministère."
      />

      <section className="py-14 md:py-20 bg-ivory">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Filters */}
          <div className="flex flex-wrap justify-center gap-3 mb-12" data-testid="video-filters">
            {FILTERS.map((f) => (
              <button
                key={f}
                onClick={() => setActive(f)}
                data-testid={`video-filter-${f.toLowerCase()}`}
                className={`px-5 py-2.5 rounded-full text-sm font-semibold tracking-wide transition-all duration-300 ${
                  active === f
                    ? "bg-gold text-white shadow-md shadow-gold/25"
                    : "bg-white text-brown-black/70 border border-gold/25 hover:border-gold hover:text-gold"
                }`}
              >
                {f}
              </button>
            ))}
          </div>

          {loading ? (
            <p className="text-center text-brown-black/50">Chargement…</p>
          ) : filtered.length === 0 ? (
            <p className="text-center text-brown-black/50 py-10" data-testid="videos-empty">Aucune vidéo dans cette catégorie pour le moment.</p>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filtered.map((v, i) => (
                <Reveal key={v.id} delay={(i % 3) * 0.1}>
                  <VideoCard video={v} />
                </Reveal>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Videos;
